import revive_payload_client_4sVQNw7RlN from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/builds/synthese-et-medias/data-center-front/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/builds/synthese-et-medias/data-center-front/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/builds/synthese-et-medias/data-center-front/.nuxt/sentry-client-config.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_ghbUAjaD3n from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import formkitPlugin_pZqjah0RUG from "/builds/synthese-et-medias/data-center-front/.nuxt/formkitPlugin.mjs";
import slideovers_X7whXyrIWR from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/builds/synthese-et-medias/data-center-front/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import _0_auth_reLdRJDfWy from "/builds/synthese-et-medias/data-center-front/auth/plugins/0.auth.ts";
import i18n_messages_xF66YAnszm from "/builds/synthese-et-medias/data-center-front/plugins/i18n-messages.ts";
import vue_query_wrmMkNpEpe from "/builds/synthese-et-medias/data-center-front/plugins/vue-query.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_ghbUAjaD3n,
  formkitPlugin_pZqjah0RUG,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  _0_auth_reLdRJDfWy,
  i18n_messages_xF66YAnszm,
  vue_query_wrmMkNpEpe
]